import React, { useState, useEffect } from 'react';
import Primary from './Primary';
import Secondary from './Secondary';
import SecondaryMobile from './SecondaryMobile';
import Events from './Events';

const HomeV2 = () => {
	const [isPrimaryVisible, setPrimaryVisible] = useState(true);
	const isMobile = window.innerWidth < 576;

	function ShowSecondary() {
		setPrimaryVisible(false);
	}
	useEffect(() => {
		Events.SubscribeToShowFileTable(ShowSecondary);
	}, []);
	return (
		<React.Fragment>
			<Primary visible={isPrimaryVisible} />
			{ !isPrimaryVisible && !isMobile && <Secondary /> }
			{ !isPrimaryVisible && isMobile && <SecondaryMobile /> }
		</React.Fragment>
	);
};

export default HomeV2;



// WEBPACK FOOTER //
// ./src/Home.v2.js